export default __webpack_public_path__ + "static/media/ufo-kidnap.d58fc7b6.png";